import { generatePaymentFormLink } from 'utils';

import { Bus, constants, NotificationManager } from '@atlas/core';

const BITCOIN_METHOD = 'coinspaid';
const GPAY_METHOD = 'gpay';
const PAYMAYA_METHOD = 'paymaya';
const SPEI = 'starspaySpeiDeposit';
const ATLAS_TRANSFER = 'atlasTransferDeposit';

const getPopupNotificationData = (redirectUrl, paymentMethod) => {
  if (redirectUrl.startsWith(SPEI)) {
    return {
      data: {
        paymentMethod,
        redirectUrl,
      },
      message: 'speiDeposit',
      type: 'speiDeposit',
    };
  }

  return {
    data: {
      redirectUrl,
      text: 'pix_text',
      title: 'pix_title',
    },
    message: 'pix',
    type: 'pix',
  };
};

export const depositSubmit = (data, paymentMethod, setPaymentUrl, amount, setRedirectUrl) => {
  const {
    displayOption = '',
    formData: { additionalParams = {} } = {},
    paymentFormName,
    paymentInstructions,
    paymentName,
    processingType,
    publicPaymentId,
    redirectUrl,
  } = data;
  const formId = paymentMethod.paymentForms?.[0]?.formId;

  if (processingType === constants.PAYMENT_PROCESSING.FORM && formId) {
    return NotificationManager.display({
      data: {
        amount,
        formId,
        interpolationValues: additionalParams,
        paymentMethod,
        publicPaymentId,
        type: constants.PAYMENT_OPERATION.DEPOSIT,
      },
      message: 'paymentsForm',
      type: 'paymentsForm',
    });
  }

  if (paymentFormName === 'safetypay') {
    return NotificationManager.display({
      data: {
        buttonText: 'deposit_safetypay_action_button',
        paymentName,
        redirectUrl,
        stepsPreText: 'deposit_safetypay_steps',
        stepsText: paymentInstructions && JSON.parse(paymentInstructions),
        text: 'deposit_safetypay_instruction',
        title: 'deposit_safetypay_header_title',
      },
      message: 'depositInstruction',
      type: 'depositInstruction',
    });
  }

  if (redirectUrl) {
    const redirectNotifications = [
      {
        name: ATLAS_TRANSFER,
        notification: {
          data: { paymentName, publicPaymentId, redirectUrl },
          message: 'atlasTransfer',
          type: 'atlasTransfer',
        },
      },
      {
        name: GPAY_METHOD,
        notification: {
          data: { redirectUrl },
          message: 'gpay',
          type: 'gpay',
        },
      },
      {
        name: BITCOIN_METHOD,
        notification: {
          data: { redirectUrl },
          message: 'bitcoin',
          type: 'bitcoin',
        },
      },
      {
        name: PAYMAYA_METHOD,
        notification: {
          data: { redirectUrl },
          message: 'paymaya',
          type: 'paymaya',
        },
      },
    ];
    const redirectNotificationData = redirectNotifications.find(notification =>
      redirectUrl.startsWith(notification.name),
    );

    if (redirectNotificationData) {
      return NotificationManager.display(redirectNotificationData.notification);
    }
  }

  if (processingType === 'POPUP' && redirectUrl) {
    const popupNotificationData = getPopupNotificationData(redirectUrl, paymentMethod);

    return NotificationManager.display(popupNotificationData);
  }

  if (processingType === constants.PAYMENT_PROCESSING.REDIRECT && redirectUrl) {
    Bus.emit('notification:loading', false);
    if (displayOption === 'NO_IFRAME') {
      setRedirectUrl?.();
      window.location.href = redirectUrl;
      return;
    }
    setPaymentUrl(redirectUrl);
  } else if (processingType === constants.PAYMENT_PROCESSING.FORM) {
    window.open(generatePaymentFormLink(data));
  }

  // Broadcasting custom deposit submit event
  Bus.emit('profile:depositSubmit', data);
};
